import { Color, ValueDisplayValue } from "@mcleod/core";
import { ComponentConstructor, Event, RadioButton, RadioButtonSelectionEvent } from "../..";
import { ComponentPropDefinitions } from "../../base/ComponentProps";
import { ComponentTypes } from "../../base/ComponentTypes";
import { RadioButtonGroupPropDefinitions, RadioButtonGroupProps } from "./RadioButtonGroupProps";
import { RadioGroup } from "./RadioGroup";
import { RadioOption } from "./RadioOption";
import { RadioOptionResolver } from "./RadioOptionResolver";
import { RadioOptionSelectionEvent } from "../../events/RadioOptionSelectionEvent";

export class RadioButtonGroup extends RadioGroup implements RadioButtonGroupProps {
    private _buttonSize: number;
    private _buttonFillColor: Color;
    
    constructor(props?: Partial<RadioButtonGroupProps>) {
        super(props);
    }

    override get options(): RadioButton[] {
        return super.options as RadioButton[];
    }

    get selectedOption(): RadioButton {
        return super.selectedOption as RadioButton;
    }

    set selectedOption(value: RadioButton) {
        super.selectedOption = value;
    }

    override get optionClass(): ComponentConstructor {
        return RadioButton;
    }

    override resolveOption(value: ValueDisplayValue | RadioOption): RadioOption {
        return RadioOptionResolver.resolveOption(this, value);
    }

    override resolveOptions(value: ValueDisplayValue[] | (() => ValueDisplayValue[]) | RadioOption[] |
        (() => RadioOption[])): RadioOption[]{
        return RadioOptionResolver.resolveOptions(this, value);
    }

    override createSelectionEvent(oldSelection: RadioOption, newSelection: RadioOption, originatingEvent?: Event):
        RadioOptionSelectionEvent {
        return new RadioButtonSelectionEvent(this, oldSelection, newSelection, originatingEvent)
    }

    get buttonFillColor(): Color {
        return this._buttonFillColor ?? this.getPropertyDefinitions().buttonFillColor.defaultValue;
    }

    set buttonFillColor(value: Color) {
        this._buttonFillColor = value;
        this.options?.forEach(button => button.buttonFillColor = this.buttonFillColor);
    }

    public get buttonSize(): number {
        return this._buttonSize ?? this.getPropertyDefinitions().buttonSize.defaultValue;
    }

    public set buttonSize(value: number) {
        this.options?.forEach(button => button.buttonSize = value);
    }

    override getPropertyDefinitions(): ComponentPropDefinitions {
        return RadioButtonGroupPropDefinitions.getDefinitions();
    }

    override get serializationName() {
        return "radiobuttongroup";
    }

    override get properName(): string {
        return "Radio Buttons";
    }
}
ComponentTypes.registerComponentType("radiobuttongroup", { constructor: RadioButtonGroup.prototype.constructor });
